// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.account_good[data-v-33d70db7] {\n  color: rgb(27, 185, 27);\n  font-size: 14px;\n  line-height: 120%;\n  margin-top: .25rem;\n}\n", ""]);
// Exports
module.exports = exports;
